import classNames from "classnames";
import st from "./Alert.module.scss";

interface IAlertProps extends React.HTMLAttributes<HTMLDivElement> {
    color?: "red" | "info" | "warn";
};

const Alert: React.FC<IAlertProps> = ({ color = "info", className, children, ...otherProps }) => (
    <div className={classNames( st.rdcAlert, className, st[color])} {...otherProps}>
        { children }
    </div>
);

export default Alert;
